import styled, { css, createGlobalStyle } from 'styled-components';
import { withOpacity } from 'styled-system';

export const TRANSITION_DURATION_MS = 200;

export const GlobalStyles = createGlobalStyle<{ $isOpen: boolean }>`
  #__next {
    ${({ $isOpen }) =>
      $isOpen &&
      css`
        /* Hide main content from assistive technology when modal is open */
        &[aria-hidden='true'] {
          /* Ensure focus cannot escape to hidden content */
          pointer-events: none;
        }
      `}
  }
`;

export const Overlay = styled.div<{ isOpen: boolean }>`
  position: fixed;
  inset: 0;
  z-index: ${({ theme }) => theme.donedeal.zIndices.MODAL};
  background-color: ${({ theme, isOpen }) =>
    isOpen
      ? withOpacity(theme.donedeal.colors.GREY_DARKER, 0.8)
      : 'transparent'};
  transition: background-color ${TRANSITION_DURATION_MS}ms ease-in-out;

  visibility: ${({ isOpen }) => (isOpen ? 'visible' : 'hidden')};
  opacity: ${({ isOpen }) => (isOpen ? 1 : 0)};
  pointer-events: ${({ isOpen }) => (isOpen ? 'auto' : 'none')};

  /* Delay visibility change on close to allow transition to complete */
  ${({ isOpen }) =>
    !isOpen &&
    css`
      transition: background-color ${TRANSITION_DURATION_MS}ms ease-in-out,
        visibility 0ms ${TRANSITION_DURATION_MS}ms,
        opacity ${TRANSITION_DURATION_MS}ms ease-in-out;
    `}

  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }
`;

export const ModalContent = styled.div<{
  isOpen: boolean;
}>`
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  top: 16px;
  width: 100%;
  height: ${({ theme }) => `calc(100% - ${theme.spacing.M16})`};
  z-index: ${({ theme }) => theme.donedeal.zIndices.MODAL};
  background-color: ${({ theme }) => theme.donedeal.colors.WHITE};
  border-radius: ${({ theme }) =>
    `${theme.borderRadius.default} ${theme.borderRadius.default} 0 0`};
  display: flex;
  flex-direction: column;
  overflow: hidden;
  transform: ${({ isOpen }) => (isOpen ? 'translateY(0)' : 'translateY(100%)')};
  transition: transform ${TRANSITION_DURATION_MS}ms ease-out;

  /** Default to hidden, the visibility will be managed by reference
   * to allow imperatively managing the visibility of the modal content.
   *
   * This is needed on iOS for example when we want to display the soft keyboard
   * when focusing an input inside the modal content.
   */
  visibility: hidden;
  pointer-events: ${({ isOpen }) => (isOpen ? 'auto' : 'none')};

  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }
`;
